import { UPDATE_PAGES } from "../actionTypes";

const INITIAL_STATE = {};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PAGES:
      return { ...state, ...action.payload.entities.pages };
    default:
      return state;
  }
};

export default reducer;
